import { Box, Stack, Typography, styled } from "@mui/material";
import { FONT_COLORS } from "../../../../constants";
import { ReactNode } from "react";
import { Logo } from "../../../../components";

type THeaderProps = {
  title: string;
  subtitle: string | ReactNode;
  disableCompanyIdentity?: boolean;
};

export const Header = ({
  title,
  subtitle,
  disableCompanyIdentity,
}: THeaderProps) => {
  return (
    <Box mb={4}>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap="12px"
        mb={2}
        flexWrap="wrap"
      >
        <Typography
          variant="h1"
          component="h1"
          fontSize={36}
          fontWeight={700}
          textAlign="center"
          color={FONT_COLORS.default}
          whiteSpace="nowrap"
        >
          {title}
        </Typography>
        {!disableCompanyIdentity && <Logo variant="dark" height={36} />}
      </Stack>
      {typeof subtitle === "string" ? (
        <Typography
          variant="h2"
          component="h2"
          fontSize={16}
          fontWeight={400}
          textAlign="center"
          color={FONT_COLORS.default}
        >
          {subtitle}
        </Typography>
      ) : (
        subtitle
      )}
    </Box>
  );
};
